export const TAXES_INFO_FIELDS = ['usTaxPayer', 'taxPayerOutsideLegalCountry'];
